



















import Vue from 'vue'
import RegisterEmail from '@/components/register/RegisterEmail.vue'
import RegisterPassword from '@/components/register/RegisterPassword.vue'
import RegisterLogin from '@/components/register/RegisterLogin.vue'

export default Vue.extend({
  name: 'Register',
  components: {
    RegisterEmail,
    RegisterPassword,
    RegisterLogin
  },
  data: () => ({
    email: '' as string,
    registered: false as boolean,
    error: '' as string
  }),
  computed: {
    emailAvailable (): boolean {
      return !!this.email && this.email !== ''
    },
    showSuccess (): boolean {
      return this.registered === true && this.emailAvailable
    },
    showError (): boolean {
      return !!this.error && this.error !== ''
    }
  },
  methods: {
    // a function to bind to child input components to set their value on the parent
    setFieldValue (value, name): void {
      this[name] = value
    }
  }
})
